<div class="flight-item__details">
  <div class="panel panel-default panel--shadow" *ngIf="selectedFlight === null">
    <div class="panel-body">
      <h4>{{ appCopy.panelHeader['titleArrivalFlight'+selectedLanguage] }}</h4>
      <ul class="list-unstyled flight-results margin-bottom-12">
        <li *ngFor="let item of filteredCombinedFlights; let i = index" id="combinedFlight{{i}}"
          (keyup.enter)="handleSelectFlight($event, item)" (click)="handleSelectFlight($event, item)" tabindex="0">
          <div class="flight-item panel panel--shadow">
            <div class="panel-body flex-always">
              <div
                [ngClass]="'hidden-xs airline-logo airline-logo--' + item.flightStatusDetails[item.flightStatusDetails.length - 1].airlineCode.replace('*', '')">
              </div>
              <div class="flex__item--grow">
                <p>{{ item.flightStatusDetails[item.flightStatusDetails.length - 1].airlineName }}</p>
                <p><span class="hidden-xs">{{ appCopy.panelHeader['titleFlight'+selectedLanguage] }} </span>{{
                  item.flightStatusDetails[item.flightStatusDetails.length -
                  1].airlineCodeDisplayName }}{{ item.flightStatusDetails[item.flightStatusDetails.length -
                  1].flightNumber }}</p>
                <p class="flex-always text-extra-bold">
                  {{ item.flightStatusDetails[item.flightStatusDetails.length - 1].departureAirport.airportCode }}
                  <span class="leg-divider"></span>
                  {{ item.flightStatusDetails[item.flightStatusDetails.length - 1].arrivalAirport.airportCode }}
                </p>
              </div>
              <div class="flex-divider margin-right-0 hidden-sm hidden-xs"></div>
              <div class="flex-lg flex-md flex_col flight-info flight-item__departure">
                <div class="flight-info__departure">
                  <p>{{ appCopy.panelHeader['titleDeparts'+selectedLanguage] }}</p>
                  <h4 class="text-extra-bold margin-top-0 margin-bottom-0">{{
                    item.flightStatusDetails[item.flightStatusDetails.length -
                    1].departureDateTimeDetails.scheduledDateTimeLocal | amDateFormat: 'HH:mm' }}</h4>
                </div>
                <div class="flight-info__arrival">
                  <p>{{ appCopy.panelHeader['titleArrives'+selectedLanguage] }}</p>
                  <h4 class="text-extra-bold margin-top-0 margin-bottom-0">{{
                    item.flightStatusDetails[item.flightStatusDetails.length -
                    1].arrivalDateTimeDetails.scheduledDateTimeLocal | amDateFormat: 'HH:mm' }} <sup style="text-transform: none;"><b>{{timeDifferent.multiRoute[i] ? '+' + timeDifferent.multiRoute[i] + appCopy.panelHeader['d'+selectedLanguage] : ''}}</b></sup></h4>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <div class="panel panel-default panel--shadow fadeIn" *ngIf="selectedFlight !== null">
    <div class="panel-body fadeIn" *ngIf="productAlert === 'unsupported'">
      <div class="alert alert-danger margin-bottom-0">
        <!-- <h6 class="margin-top-0 margin-bottom-8">{{ appCopy.panelHeader['titleUnsupported'+selectedLanguage] }}</h6> -->
        <p>{{errPageCode + '-' +  appCopy.panelHeader['titleUnsupported'+selectedLanguage] }}</p>
      </div>
    </div>
    <!-- <div class="panel-body fadeIn" *ngIf="productAlert === 'ccd' && flightDirection === 1">
      <div class="alert alert-info margin-bottom-0">
        <h6 class="margin-top-0 margin-bottom-8">Airport Delivery</h6>
        <p>This flight isn't eligible for remote bag check-in, so we'll take it from your address to the airport, but
          you need to <strong>pick it up from us before security and check-in yourself</strong>.</p>
      </div>
    </div> -->
    <!-- <div class="panel-body fadeIn" *ngIf="productAlert === 'ccd' && flightDirection === 2">
      <div class="alert alert-info margin-bottom-0">
        <h6 class="margin-top-0 margin-bottom-8">City Delivery</h6>
        <p>Drop your bags with our airport team and we'll deliver them to your home, hotel or business.</p>
      </div>
    </div> -->
    <div class="leg leg--first panel-body">
      <div class="row">
        <div class="col-lg-6 col-md-6">
          <div class="leg__content">
            <p>
              <span class="airport-name">
                {{ appAirportCopy[selectedFlight.flightStatusDetails[0].departureAirport.airportCode]['airportCityName'+selectedLanguage]}}
              </span>
              {{ selectedFlight.flightStatusDetails[0].departureAirport.airportCode }}
            </p>
            <div>
              <strong>{{selectedFlight.flightStatusDetails[0].airlineCode + selectedFlight.flightStatusDetails[0].flightNumber}} <span (click)="toggleFlightInfoModal(selectedFlight)" id="info" class="icon-information icon-black icon_18"></span> </strong>
            </div>
            <p>
              {{ appAirportCopy[selectedFlight.flightStatusDetails[0].departureAirport.airportCode]['airportName'+selectedLanguage]}}
            </p>
            <p class="badge" *ngIf="flightDirection === 1">
              {{ ukTerminal === null ? appCopy.panelHeader['helperTextLoading'+selectedLanguage] :
              appCopy.panelHeader['titleTerminal'+selectedLanguage]+ " " +
              ukTerminal }}
            </p>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 hidden-sm hidden-xs">
          <div>
            <p class="text-caption">{{ appCopy.panelHeader['titleDeparts'+selectedLanguage] }}</p>
            <p>
              {{selectedFlight.flightStatusDetails[0].departureDateTimeDetails.scheduledDateTimeLocal | date:'E, d MMM yyyy' :'' : languageCode }}
              {{ appCopy.panelHeader['at'+selectedLanguage] }}
              {{ selectedFlight.flightStatusDetails[0].departureDateTimeDetails.scheduledDateTimeLocal | amDateFormat:
                'HH:mm' }}</p>
          </div>
          <div *ngIf="selectedFlight.flightStatusDetails.length > 1">
            <p class="text-caption">{{ appCopy.panelHeader['titleArrives'+selectedLanguage] }}</p>
            <p>
              {{selectedFlight.flightStatusDetails[0].arrivalDateTimeDetails.scheduledDateTimeLocal | date:'E, d MMM yyyy' :'' : languageCode }}
              {{ appCopy.panelHeader['at'+selectedLanguage] }}
              {{ selectedFlight.flightStatusDetails[0].arrivalDateTimeDetails.scheduledDateTimeLocal | amDateFormat:
                'HH:mm' }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="leg leg--middle panel-body padding-top-0 padding-bottom-0 padding-right-0 bg-primary-light"
      *ngIf="selectedFlight.flightStatusDetails.length > 1">
      <div class="leg__content" *ngFor="let leg of selectedFlight.flightStatusDetails | slice:1">
        {{ appAirportCopy[leg.departureAirport.airportCode]['airportName'+selectedLanguage]}}
      </div>
    </div>
    <div class="leg leg--last panel-body">
      <div class="row">
        <div class="col-lg-6 col-md-6">
          <div class="leg__content">
            <p>
              <span class="airport-name">
                {{ appAirportCopy[selectedFlight.flightStatusDetails[selectedFlight.flightStatusDetails.length - 1].arrivalAirport.airportCode]['airportCityName'+selectedLanguage]}}
              </span>
              {{ selectedFlight.flightStatusDetails[selectedFlight.flightStatusDetails.length - 1].arrivalAirport.airportCode }}
            </p>
            <div *ngIf="selectedFlight.flightStatusDetails.length > 1">
              <div *ngFor="let leg of selectedFlight.flightStatusDetails | slice:1">
                <strong>{{ leg.airlineCode }}{{ leg.flightNumber }} <span (click)="toggleFlightInfoModal(leg)" id="info" class="icon-information icon-black icon_18"></span> </strong>
              </div>
            </div>
            <p>
              {{ appAirportCopy[selectedFlight.flightStatusDetails[selectedFlight.flightStatusDetails.length - 1].arrivalAirport.airportCode]['airportName'+selectedLanguage]}}
            </p>
            <p class="badge" *ngIf="flightDirection === 2">
              {{ ukTerminal === null ? appCopy.panelHeader['helperTextLoading'+selectedLanguage] : 'Terminal ' +
              ukTerminal }}
            </p>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 hidden-sm hidden-xs">
          <div *ngIf="selectedFlight.flightStatusDetails.length > 1">
            <p class="text-caption">{{ appCopy.panelHeader['titleDeparts'+selectedLanguage] }}</p>
            <p>{{ selectedFlight.flightStatusDetails[selectedFlight.flightStatusDetails.length -
              1].departureDateTimeDetails.scheduledDateTimeLocal | date:'E, d MMM yyyy' :'' : languageCode }} {{
              appCopy.panelHeader['at'+selectedLanguage] }} {{
              selectedFlight.flightStatusDetails[selectedFlight.flightStatusDetails.length -
              1].departureDateTimeDetails.scheduledDateTimeLocal | amDateFormat: 'HH:mm' }}</p>
          </div>
          <div>
            <p class="text-caption">{{ appCopy.panelHeader['titleArrives'+selectedLanguage] }}</p>
            <p>{{ selectedFlight.flightStatusDetails[selectedFlight.flightStatusDetails.length -
              1].arrivalDateTimeDetails.scheduledDateTimeLocal | date:'E, d MMM yyyy' :'' : languageCode }} {{
              appCopy.panelHeader['at'+selectedLanguage] }} {{
              selectedFlight.flightStatusDetails[selectedFlight.flightStatusDetails.length -
              1].arrivalDateTimeDetails.scheduledDateTimeLocal | amDateFormat: 'HH:mm' }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-body padding-top-0 no-border">
      <div class="row flight-actions">
        <div class="col-lg-6 col-md-6 col-sm-6">
          <button class="btn btn-default btn-block" (click)="handleCancelFlight($event)">{{
            appCopy.panelHeader['buttonIsNotMyFlight'+selectedLanguage] }}</button>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6">
          <button class="btn btn-flight btn-block" [ngClass]="isLoading && 'Buttonloading'" [disabled]="isLoading || productAlert === 'unsupported'"
            (click)="handleConfirmFlight($event, selectedFlight)">
            <!-- <div class="loader-container-btn" *ngIf="isLoading">
              <div class="loader loader--white">
                <svg class="circular" viewBox="25 25 50 50">
                  <circle class="path" cx="50" cy="50" r="20" />
                </svg>
              </div>
            </div> -->
            <span *ngIf="!isLoading">{{ appCopy.panelHeader['buttonIsMyFlight'+selectedLanguage] }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- // updated for ccd/abc critical case -->
<app-modal-product-type *ngIf="modalProductType" [com]="'FlightDetails'" (confirmFlightProductType)="getSelectedProductType($event)"
  [searchByFlightNumber]="searchByFlightNumber" [modalData]="modalData">
</app-modal-product-type>
